import { useEffect, useState } from "react";

import {
  fetchWmsClassLegend,
  getCachedWmsClassLegend,
  type WmsClassLegendItem,
} from "../services/wmsClassLegend";

interface WmsLayerRef {
  layerName: string;
  workspace?: string;
  type?: string;
  manualLegend?: unknown;
}

/**
 * Classes do SLD do servidor para as camadas `type: "wms"` ativas — elas não
 * têm estilo no front, então sem isso apareceriam na legenda como um traço
 * genérico único.
 */
export function useWmsClassLegends(
  layers: WmsLayerRef[]
): Record<string, WmsClassLegendItem[]> {
  const [legends, setLegends] = useState<Record<string, WmsClassLegendItem[]>>(
    {}
  );

  const key = layers
    .filter((l) => l.type === "wms" && l.workspace && !l.manualLegend)
    .map((l) => `${l.workspace}:${l.layerName}`)
    .sort()
    .join(",");

  useEffect(() => {
    if (!key) return;
    let cancelled = false;

    Promise.all(
      key.split(",").map(async (ref) => {
        const [workspace, layerName] = ref.split(":");
        const items =
          getCachedWmsClassLegend({ workspace, layerName }) ??
          (await fetchWmsClassLegend({ workspace, layerName }));
        return [layerName, items] as const;
      })
    ).then((entries) => {
      if (cancelled) return;
      setLegends(Object.fromEntries(entries.filter(([, i]) => i.length > 0)));
    });

    return () => {
      cancelled = true;
    };
  }, [key]);

  return legends;
}
